import React from 'react';

import { useGetFaces } from '@vlabs/api/artemy/client';
import type { Uuid } from '@vlabs/api/artemy/model';
import { useCardIdFromLocationPoint3 } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { useTranslation } from 'react-i18next';

import st from './CardFacesViewer.module.sass';
import { PersonFaceCard } from './person-face-card';

const displayName = 'CardFacesViewer';
const testid = buildTestid(displayName);

export function CardFacesViewer(): React.JSX.Element {
  const cardId = useCardIdFromLocationPoint3();
  const { t } = useTranslation();
  const getCardFaces = useGetFaces({
    card_ids: [cardId],
  });

  const faces = getCardFaces.data?.faces ?? [];
  const hasFaces = faces.length > 0;

  return (
    <div
      className={st.CardList}
      {...testid()}
    >
      {!!hasFaces && faces.map((face) => (
        <PersonFaceCard
          faceId={face.face_id as Uuid}
          key={face.face_id as Uuid}
        />
      ))}

      {!hasFaces && (
        <div
          className={st.EmptyPage}
          data-testid="externalId.emptyPage"
        >
          {t('no data available')}
        </div>
      )}
    </div>
  );
}
